import { render, staticRenderFns } from "./LocaleToggle.vue?vue&type=template&id=cc47bc88"
import script from "./LocaleToggle.vue?vue&type=script&lang=js"
export * from "./LocaleToggle.vue?vue&type=script&lang=js"
import style0 from "./LocaleToggle.vue?vue&type=style&index=0&id=cc47bc88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports